module.exports = __webpack_public_path__ + "media/images/person/review_cathy-60d1ae374d911753f8026f3093c6cbc9.jpg";